const logo = require('../assets/logo.png');
const logout = require('../assets/logout.png');
const search = require('../assets/search.png');
const location = require('../assets/location.png');
const tick = require('../assets/tick.png');
const dispatch = require('../assets/dispatch.png');
const warning = require('../assets/warning.png');
const star = require('../assets/star.png');
const error = require('../assets/error.png');
const close = require('../assets/close.png');
const loginBackground = require('../assets/loginBackground.png');
const hungerStation = require('../assets/hunger_station.png');
const otlob = require('../assets/otlob.png');
const otlobDark = require('../assets/otlob_dark.png');
const talabat = require('../assets/talabat.png');
const zomato = require('../assets/zomato.png');
const grubtech = require('../assets/grubtech.png');
const grubtechAlt = require('../assets/gt.PNG');
const grubtechDark = require('../assets/gtDark.PNG');
const deliveroo = require('../assets/deliveroo.png');

const careembox = require('../assets/careembox.jpg');
const careemnow = require('../assets/careemnow.png');
const jahez = require('../assets/jahez.png');
const jeebly = require('../assets/jeebly.png');
const quiqup = require('../assets/quiqup.png');
const quiqupDark = require('../assets/quiqup_dark.png');
const oneclick = require('../assets/oneclick.png');

const inhouse = require('../assets/inhouse.png');
const inhouseDark = require('../assets/inhouse_dark.png');
const blank = require('../assets/blank.png');
const blankDark = require('../assets/blank_dark.png');

const deliveryMan = require('../assets/delivery_man.png');
const successfullyAssigned = require('../assets/successfully_assigned.png');
const conflictDetected = require('../assets/conflict_detected.png');

const settings = require('../assets/settings.png')
const helmet = require('../assets/helmet.png')
const bell = require('../assets/bell.png')
const backArrow = require('../assets/back_arrow.png')
const warningYellow = require('../assets/warning-yellow.png')

const expandMore = require('../assets/expand_more.png')
const driverCallInProgress = require('../assets/driver_call_inprogress.png')
const redCross = require('../assets/red-cross.png')

const logoWhite = require('../assets/logo_white.png')
const logoBlack = require('../assets/logo_black.png')
const logoColor = require('../assets/logo_color.png')


export default {
  hungerStation,
  otlob,
  otlobDark,
  talabat,
  zomato,
  grubtech,
  grubtechAlt,
  grubtechDark,
  deliveroo,
  inhouse,
  inhouseDark,
  blank,
  blankDark,
  careembox,
  careemnow,
  jahez,
  jeebly,
  quiqup,
  quiqupDark,
  oneclick,
  logo,
  logout,
  search,
  location,
  tick,
  dispatch,
  warning,
  star,
  error,
  close,
  loginBackground,
  deliveryMan,
  successfullyAssigned,
  conflictDetected,
  settings,
  helmet,
  bell,
  backArrow,
  warningYellow,
  expandMore,
  driverCallInProgress,
  redCross,
  logoWhite,
  logoBlack,
  logoColor
};
